var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectIsEventQuest, selectQuestsIsTimeChallenge, } from "../../../../balancingSelectors/selectBalancingQuests";
import { IdStyles } from "../../../../less/IdStyles";
import { selectIsQuestCompleted, selectIsQuestNew, selectSelectedQuest, } from "../../../../selectors/selectQuestInfo";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { Badge } from "../../../generic/badge/Badge";
import { IdBadgePosition } from "../../../generic/badge/IdBadgePosition";
import { Icon } from "../../../generic/icon/Icon";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { TextLoca } from "../../../generic/text/TextLoca";
var QuestButtonDOM = function (_a) {
    var quest = _a.quest, iconStyle = _a.iconStyle, selectedQuest = _a.selectedQuest, showSelectedQuest = _a.showSelectedQuest, onClick = _a.onClick, getButton = _a.getButton, getIsQuestCompleted = _a.getIsQuestCompleted, getIsQuestNew = _a.getIsQuestNew, recommendedQuestId = _a.recommendedQuestId, _b = _a.questBadgeClassName, questBadgeClassName = _b === void 0 ? "" : _b, _c = _a.renderTooltips, renderTooltips = _c === void 0 ? true : _c;
    var isQuestRecommended = function (questType) { return questType.id === recommendedQuestId; };
    var questSelected = selectedQuest.id === quest.id && showSelectedQuest;
    var questSelectedState = questSelected ? "selected" : "";
    var isQuestTimeChallenge = selectQuestsIsTimeChallenge(quest);
    var isEventQuest = selectIsEventQuest(quest);
    var isQuestCompleted = getIsQuestCompleted(quest);
    var Component = getButton(isQuestCompleted, isQuestRecommended(quest), isQuestTimeChallenge);
    var isQuestNew = getIsQuestNew(quest);
    var getBadge = function () {
        if (isQuestCompleted) {
            return (React.createElement("div", { className: questBadgeClassName },
                React.createElement(Badge, { position: IdBadgePosition.TopRight },
                    React.createElement(Icon, { icon: IdIcon.GiftShopIcn, styleId: IdStyles.IconMedium }))));
        }
        else if (isQuestNew) {
            return (React.createElement("div", { className: questBadgeClassName },
                React.createElement(Badge, { position: IdBadgePosition.TopRight },
                    React.createElement(Icon, { icon: IdIcon.QuestUpdateIcn, styleId: IdStyles.IconMedium }))));
        }
        else if (isEventQuest && questBadgeClassName === "") {
            return (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconMedium })));
        }
        return undefined;
    };
    var QuestBadge = getBadge();
    var buttonProps = {
        children: "Q_" + quest.id,
        className: "quest " + questSelectedState,
        disabled: false,
        onClick: function () { return onClick(quest); },
    };
    var hasRemainingTime = quest.timeToLive;
    var showTooltip = renderTooltips ? isQuestCompleted || isQuestNew : false;
    var tooltipClassName = isQuestCompleted
        ? "tooltip__text tooltip__text__quest tooltip__text__quest--left quest-tooltip__container"
        : "tooltip__text tooltip__text--left";
    return (React.createElement("div", { key: "Q_" + quest.id },
        React.createElement(Component, __assign({}, buttonProps),
            React.createElement("div", { className: "h100 w100" },
                showTooltip && (React.createElement("div", { className: "mouse-hover", onClick: function () { return buttonProps.onClick(); } },
                    React.createElement(TextLoca, { style: { left: 105 }, className: tooltipClassName + " " + IdStyles.TextNormal, id: isQuestCompleted
                            ? IdLoca.tooltip_getReward_web
                            : IdLoca.tooltip_newQuest_web }))),
                QuestBadge,
                hasRemainingTime && (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                    React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall }))),
                React.createElement("div", { className: "flex flex--centered flex--aligned container w100" },
                    React.createElement(Icon, { icon: quest.buttonIconLeft, styleId: iconStyle }),
                    React.createElement(Icon, { icon: quest.buttonIconRight, styleId: iconStyle }))))));
};
var mapState = function (state) {
    return {
        getIsQuestCompleted: function (quest) { return selectIsQuestCompleted(state, quest); },
        getIsQuestNew: function (quest) { return selectIsQuestNew(state, quest); },
        selectedQuest: selectSelectedQuest(state),
    };
};
export var QuestButton = connect(mapState)(QuestButtonDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestButton.tsx
// module id = 879
// module chunks = 3